import { mapApiDataToOperators } from '@/lib/cms-mappers';
import { guidesLocales } from '@/config/locales';

import type { FOperatorsTemplateProps } from '@/components/templates/FOperatorsTemplate.vue';

const populateFields = [
  'explore_section.blog_posts.main_image',
  'featured_guide',
];

/**
 * Returns featured guide and blog posts data fetched from CMS (Strapi)
 */
export async function useCmsOperators(): UseCmsResponse<FOperatorsTemplateProps> {
  const { t } = useI18n();
  const { data, error, pending, refresh } = await useStrapi('operator', {
    localesSubset: guidesLocales,
    queryParams: {
      populate: populateFields.join(','),
    },
  });
  const mappedData = computed(() => mapApiDataToOperators(data.value?.data));
  const i18nMappedData = computed<FOperatorsTemplateProps>(() => ({
    featuredGuide: mappedData.value.featuredGuide,
    blogPostCards: mappedData.value.blogPostCards.map(card => ({
      ...card,
      linkText: t('blog__related_posts__cards__button_text'),
    })),
  }));
  return { data: i18nMappedData, error, pending, refresh };
}
